import React from 'react';

import Image, { StaticImageData } from 'next/image';
import { ArrowLinkProps } from 'Elements/Link/Arrow';

import {
    Container,
    SimplifiedMobileLink,
    Content,
    ImageWrapper,
    Heading,
    Description,
    StyledArrowLink
} from './Card.styled';

export interface Props {
    image: {
        src: StaticImageData | string;
        alt?: string;
    };
    heading?: string;
    headingType?: 'h2' | 'h3';
    headingColour?: React.CSSProperties['color'];
    description: string;
    link?: ArrowLinkProps;
    backgroundColour?: React.CSSProperties['color'];
    includeInnerPadding?: boolean;
    useSimplifiedMobileLayout?: boolean;
}

const Card: React.FC<Props> = props => {
    const {
        image,
        heading,
        headingType = 'h3',
        headingColour,
        description,
        link,
        backgroundColour,
        includeInnerPadding = false,
        useSimplifiedMobileLayout = false
    } = props;

    return (
        <Container
            $useSimplifiedMobileLayout={useSimplifiedMobileLayout}
            style={
                {
                    '--card-bg-colour': backgroundColour
                } as React.CSSProperties
            }
        >
            {link?.href && <SimplifiedMobileLink href={link.href} />}
            <ImageWrapper
                $includeInnerPadding={includeInnerPadding}
                $useSimplifiedMobileLayout={useSimplifiedMobileLayout}
            >
                <Image src={image.src} alt={image.alt || ''} fill style={{ objectFit: 'cover' }} />
            </ImageWrapper>
            <Content $includeInnerPadding={includeInnerPadding}>
                {heading && (
                    <Heading
                        as={headingType}
                        $useSimplifiedMobileLayout={useSimplifiedMobileLayout}
                        style={{ '--card-h-colour': headingColour } as React.CSSProperties}
                    >
                        {heading}
                    </Heading>
                )}
                <Description>{description}</Description>
                {link && <StyledArrowLink {...link} />}
            </Content>
        </Container>
    );
};

export default Card;
